<template>
  <div class="popup-overlayer">
    <div class="popup">
      <a @click="$emit('close')" href="javascript:void(0)" class="close-btn"><i class="fas fa-times"></i></a>
      <h2>Vonalkód igénylés</h2>

      <form>
        <div class="row">
          <div class="col-sm-12">
            <inputbox :errors="errors" regexp_filter="[0-9]+" label="Vonalkód darabszám" key="amount" id="amount" v-model="request.amount" />
            <textareabox :errors="errors" label="Megjegyzés" key="comment" id="comment" v-model="request.comment"/>
            <comboboxV2 :errors="errors" label="Csoport" id="group_id" name="group_id" :options="groups" v-model="request.group_id"/>
          </div>

          <div class="col-sm-12 align-right">
            <button @click="save" class="button" type="button" :disabled="loading">
              <i v-if="loading" class="fa fa-spinner fa-pulse fa-fw"></i>
              <span v-else>Mentés</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: [Number, String],
      required: false
    }
  },
  data() {
    return {
      loading: false,
      request: {
        id: 0,
        amount: '',
        comment: '',
        group_id: 0
      },
      groups: [],
      errors: []
    };
  },
  mounted: function() {
    var _this = this;

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('barcodeRequest/' + _this.$root.user.apikey + '/' + _this.id, {
        success: function(response) {
          _this.groups = response.groups;

          if (response.request != undefined) {
            _this.request = response.request;
          } else {
            _this.request.group_id = _this.groups[0].value;
          }
        }
      });
    });
  },
  methods: {
    save: function() {
      var _this = this;

      this.loading = true;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('barcodeRequest/save/' + _this.$root.user.apikey, {
          method: 'POST',
          data: _this.request,
          success: function(response) {
            _this.loading = false;

            if (response.errors == undefined) {
              _this.$emit('success');
              _this.$emit('close');
            } else {
              _this.errors = response.errors;
            }
          }
        });
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// popup.vue?5b8beba9